export const redirectTypes = {
    REDIRECT: 'REDIRECT',
    CLEAR: 'REDIRECT Clear',
};
